import makeStyles from "@mui/styles/makeStyles";

export const useAlertStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    minHeight: 40,
    padding: "4px 8px",
    background: theme.palette.grey[100],
    color: theme.palette.grey[900],
    lineHeight: "16px",
    fontSize: 14,
  },
  icon: {
    margin: "0 8px 0 0",
    padding: 0,
    "& > svg": {
      width: 16,
      height: 16,
      fill: "currentColor",
    },
  },
  message: {
    padding: 0,
  },
  standardError: {
    "& svg": {
      color: theme.palette.red.main,
    },
  },
  standardSuccess: {
    "& svg": {
      color: theme.palette.primary.main,
    },
  },
  standardWarning: {
    "& svg": {
      color: theme.palette.yellow.main,
    },
  },
  standardInfo: {
    "& svg": {
      color: theme.palette.blue.main,
    },
  },
  filledError: {
    background: theme.palette.red.lighter,
    "& svg": {
      color: theme.palette.red.dark,
    },
  },
  filledSuccess: {
    background: theme.palette.primary.lighter,
    "& svg": {
      color: theme.palette.primary.main,
    },
  },
  filledWarning: {
    background: theme.palette.yellow.lighter,
    "& svg": {
      color: theme.palette.yellow.dark,
    },
  },
  filledInfo: {
    background: theme.palette.blue.lighter,
    "& svg": {
      color: theme.palette.blue.dark,
    },
  },
  action: {
    alignItems: "flex-start",
    marginRight: 0,
    paddingLeft: 4,
    padding: 0,
    "& > button": {
      width: 16,
      height: 16,
      "& svg": {
        width: 16,
        height: 16,
        fill: "currentColor",
      },
    },
  },
}));

export const useStyles = makeStyles((theme) => ({
  small: {
    fontSize: 12,
    minHeight: 24,
    "& svg": {
      width: 16,
      height: 16,
    },
  },
  noBorderRadius: {
    borderRadius: 0,
  },
  noTopBorderRadius: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  bgWhite: {
    background: theme.palette.common.white,
  },
}));
